import { cn } from "@/components/podkit/lib/cn";
import { useState, type FC } from "react";

type ImageThumbnailProps = {
    src: string;
    alt: string;
    onClick: () => void;
    className?: string;
    showLabel?: boolean;
};

export const ImageThumbnail: FC<ImageThumbnailProps> = ({ src, alt, onClick, className, showLabel }) => {
    const [failed, setFailed] = useState(false);

    if (failed) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                "flex flex-col overflow-hidden rounded-lg border border-border-subtle transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-content-link",
                className,
            )}
            aria-label={`View image: ${alt || "uploaded image"}`}
            data-tracking-id="image-thumbnail-view"
        >
            <img src={src} alt={alt} className="min-h-0 flex-1 object-contain" onError={() => setFailed(true)} />
            {showLabel && alt && (
                <span className="w-full truncate border-t border-border-subtle bg-surface-secondary px-2 py-1 text-left text-xs text-content-secondary">
                    {alt}
                </span>
            )}
        </button>
    );
};
